module.exports = __webpack_public_path__ + "media/images/mailer-image-aedcc75e96b3580cb993f27a1bcc297e.jpg";